module.exports = (__webpack_require__(25))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/slicer_cli_web/web_client/views/Panel.js from dll-reference girder_plugin_slicer_cli_web
// module id = 24
// module chunks = 0